/* eslint-disable eqeqeq */

import Data from 'data';

function ColorCalculator(stdlib, foreign, heap) {
  "use asm";

  var f32 = new stdlib.Float32Array(heap);
  var u32 = new stdlib.Uint32Array(heap);
  var u8 = new stdlib.Uint8Array(heap);
  var min = stdlib.Math.min;
  var max = stdlib.Math.max;
  var abs = stdlib.Math.abs;
  var floor = stdlib.Math.floor;
  var log = stdlib.Math.log;
  var exp = stdlib.Math.exp;
  var fround = stdlib.Math.fround;

  function pixelTint() {
    f32[41] = f32[37];
    f32[42] = f32[38];
    f32[43] = f32[39];
    f32[44] = f32[40];
    f32[37] = f32[26] + f32[15];
    f32[38] = f32[27] + f32[15];
    f32[39] = f32[28] + f32[15];
    f32[37] = fround(abs(+f32[37])) * f32[16];
    f32[38] = fround(abs(+f32[38])) * f32[16];
    f32[39] = fround(abs(+f32[39])) * f32[16];
    f32[37] = log(+f32[37]);
    f32[38] = log(+f32[38]);
    f32[39] = log(+f32[39]);
    f32[37] = f32[37] * f32[2];
    f32[38] = f32[38] * f32[2];
    f32[39] = f32[39] * f32[2];
    f32[37] = exp(+f32[37]);
    f32[38] = exp(+f32[38]);
    f32[39] = exp(+f32[39]);
    u32[49] = (fround(f32[26]) < fround(f32[13]) ? -1 : 0);
    u32[50] = (fround(f32[27]) < fround(f32[13]) ? -1 : 0);
    u32[51] = (fround(f32[28]) < fround(f32[13]) ? -1 : 0);
    f32[45] = f32[26] * f32[14];
    f32[46] = f32[27] * f32[14];
    f32[47] = f32[28] * f32[14];
    f32[37] = ((u32[49]|0) ? fround(f32[45]) : fround(f32[37]));
    f32[38] = ((u32[50]|0) ? fround(f32[46]) : fround(f32[38]));
    f32[39] = ((u32[51]|0) ? fround(f32[47]) : fround(f32[39]));
    f32[45] = f32[41] + f32[15];
    f32[46] = f32[42] + f32[15];
    f32[47] = f32[43] + f32[15];
    f32[45] = fround(abs(+f32[45])) * f32[16];
    f32[46] = fround(abs(+f32[46])) * f32[16];
    f32[47] = fround(abs(+f32[47])) * f32[16];
    f32[45] = log(+f32[45]);
    f32[46] = log(+f32[46]);
    f32[47] = log(+f32[47]);
    f32[45] = f32[45] * f32[2];
    f32[46] = f32[46] * f32[2];
    f32[47] = f32[47] * f32[2];
    f32[45] = exp(+f32[45]);
    f32[46] = exp(+f32[46]);
    f32[47] = exp(+f32[47]);
    u32[49] = (fround(f32[41]) < fround(f32[13]) ? -1 : 0);
    u32[50] = (fround(f32[42]) < fround(f32[13]) ? -1 : 0);
    u32[51] = (fround(f32[43]) < fround(f32[13]) ? -1 : 0);
    f32[41] = f32[41] * f32[14];
    f32[42] = f32[42] * f32[14];
    f32[43] = f32[43] * f32[14];
    f32[36] = f32[44] * f32[0];
    f32[41] = ((u32[49]|0) ? fround(f32[41]) : fround(f32[45]));
    f32[42] = ((u32[50]|0) ? fround(f32[42]) : fround(f32[46]));
    f32[43] = ((u32[51]|0) ? fround(f32[43]) : fround(f32[47]));
    f32[37] = fround(f32[41] * f32[37]) + fround(-f32[41]);
    f32[38] = fround(f32[42] * f32[38]) + fround(-f32[42]);
    f32[39] = fround(f32[43] * f32[39]) + fround(-f32[43]);
    f32[37] = fround(f32[29] * f32[37]) + f32[41];
    f32[38] = fround(f32[29] * f32[38]) + f32[42];
    f32[39] = fround(f32[29] * f32[39]) + f32[43];
    f32[41] = log(+fround(abs(+f32[37])));
    f32[42] = log(+fround(abs(+f32[38])));
    f32[43] = log(+fround(abs(+f32[39])));
    f32[40] = f32[0] / f32[2];
    f32[41] = f32[41] * f32[40];
    f32[42] = f32[42] * f32[40];
    f32[43] = f32[43] * f32[40];
    f32[41] = exp(+f32[41]);
    f32[42] = exp(+f32[42]);
    f32[43] = exp(+f32[43]);
    f32[41] = fround(f32[41] * f32[18]) + f32[19];
    f32[42] = fround(f32[42] * f32[18]) + f32[19];
    f32[43] = fround(f32[43] * f32[18]) + f32[19];
    u32[45] = (fround(f32[37]) < fround(f32[17]) ? -1 : 0);
    u32[46] = (fround(f32[38]) < fround(f32[17]) ? -1 : 0);
    u32[47] = (fround(f32[39]) < fround(f32[17]) ? -1 : 0);
    f32[37] = f32[37] * f32[1];
    f32[38] = f32[38] * f32[1];
    f32[39] = f32[39] * f32[1];
    f32[33] = ((u32[45]|0) ? fround(f32[37]) : fround(f32[41]));
    f32[34] = ((u32[46]|0) ? fround(f32[38]) : fround(f32[42]));
    f32[35] = ((u32[47]|0) ? fround(f32[39]) : fround(f32[43]));
  }

  function pixelPalette() {
    f32[41] = min(+f32[37], +f32[38]);
    f32[41] = min(+f32[39], +f32[41]);
    f32[42] = max(+f32[37], +f32[38]);
    f32[42] = max(+f32[39], +f32[42]);
    f32[41] = fround(-f32[41]) + f32[42];
    u32[43] = (fround(f32[41]) != fround(f32[3]) ? -1 : 0);
    f32[46] = f32[41] / f32[42];
    f32[49] = fround(-f32[38]) + f32[42];
    f32[50] = fround(-f32[39]) + f32[42];
    f32[51] = fround(-f32[37]) + f32[42];
    f32[44] = f32[41] * f32[4];
    f32[49] = fround(f32[49] * f32[5]) + f32[44];
    f32[50] = fround(f32[50] * f32[5]) + f32[44];
    f32[51] = fround(f32[51] * f32[5]) + f32[44];
    f32[49] = f32[49] / f32[41];
    f32[50] = f32[50] / f32[41];
    f32[51] = f32[51] / f32[41];
    f32[41] = fround(-f32[49]) + f32[50];
    f32[47] = f32[51] + f32[6];
    f32[48] = f32[49] + f32[7];
    u32[53] = (fround(f32[37]) == fround(f32[42]) ? -1 : 0);
    u32[54] = (fround(f32[38]) == fround(f32[42]) ? -1 : 0);
    u32[55] = (fround(f32[39]) == fround(f32[42]) ? -1 : 0);
    f32[47] = fround(-f32[50]) + f32[47];
    f32[48] = fround(-f32[51]) + f32[48];
    u32[44] = u32[48] & u32[55];
    f32[44] = ((u32[54]|0) ? fround(f32[47]) : fround(f32[44]));
    f32[41] = ((u32[53]|0) ? fround(f32[41]) : fround(f32[44]));
    u32[44] = (fround(f32[41]) < fround(f32[3]) ? -1 : 0);
    f32[47] = f32[41] + f32[0];
    f32[41] = ((u32[44]|0) ? fround(f32[47]) : fround(f32[41]));
    u32[44] = (fround(f32[0]) < fround(f32[41]) ? -1 : 0);
    f32[47] = f32[41] + f32[8];
    f32[45] = ((u32[44]|0) ? fround(f32[47]) : fround(f32[41]));
    u32[41] = u32[43] & u32[45];
    u32[43] = u32[43] & u32[46];
    f32[45] = f32[41] + fround(-f32[20]);
    f32[46] = f32[43] + fround(-f32[22]);
    f32[47] = fround(-abs(+f32[45])) + f32[0];
    f32[48] = fround(-abs(+f32[46])) + f32[0];
    f32[45] = min(+f32[47], +fround(abs(+f32[45])));
    f32[46] = min(+f32[48], +fround(abs(+f32[46])));
    f32[44] = f32[42] + fround(-f32[24]);
    f32[47] = fround(-abs(+f32[44])) + f32[0];
    f32[44] = min(+fround(abs(+f32[44])), +f32[47]);
    u32[45] = (fround(f32[45]) < fround(f32[21]) ? -1 : 0);
    u32[46] = (fround(f32[46]) < fround(f32[23]) ? -1 : 0);
    u32[45] = u32[46] & u32[45];
    u32[44] = (fround(f32[44]) < fround(f32[25]) ? -1 : 0);
    u32[44] = u32[44] & u32[45];
    if (u32[44]|0) {
      f32[41] = f32[41] + f32[30];
      f32[41] = f32[41] - fround(floor(fround(f32[41])));
      f32[43] = fround(f32[43] * f32[31]) + f32[43];
      f32[47] = fround(f32[42] * f32[32]) + f32[42];
      u32[42] = (fround(f32[43]) != fround(f32[3]) ? -1 : 0);
      f32[44] = f32[41] * f32[9];
      f32[44] = floor(fround(f32[44]));
      f32[49] = fround(-f32[43]) + f32[0];
      f32[45] = f32[47] * f32[49];
      f32[41] = fround(f32[41] * f32[9]) + fround(-f32[44]);
      f32[49] = fround(fround(-f32[43]) * f32[41]) + f32[0];
      f32[48] = f32[47] * f32[49];
      f32[41] = fround(-f32[41]) + f32[0];
      f32[41] = fround(fround(-f32[43]) * f32[41]) + f32[0];
      f32[46] = f32[41] * f32[47];
      u32[49] = (fround(f32[44]) == fround(f32[3]) ? -1 : 0);
      u32[50] = (fround(f32[44]) == fround(f32[0]) ? -1 : 0);
      u32[51] = (fround(f32[44]) == fround(f32[10]) ? -1 : 0);
      u32[52] = (fround(f32[44]) == fround(f32[11]) ? -1 : 0);
      u32[41] = (fround(f32[44]) == fround(f32[12]) ? -1 : 0);
      f32[53] = ((u32[41]|0) ? fround(f32[46]) : fround(f32[47]));
      f32[55] = ((u32[41]|0) ? fround(f32[47]) : fround(f32[48]));
      f32[54] = f32[45];
      f32[41] = ((u32[52]|0) ? fround(f32[45]) : fround(f32[53]));
      f32[43] = ((u32[52]|0) ? fround(f32[48]) : fround(f32[54]));
      f32[44] = ((u32[52]|0) ? fround(f32[47]) : fround(f32[55]));
      f32[41] = ((u32[51]|0) ? fround(f32[45]) : fround(f32[41]));
      f32[43] = ((u32[51]|0) ? fround(f32[47]) : fround(f32[43]));
      f32[44] = ((u32[51]|0) ? fround(f32[46]) : fround(f32[44]));
      f32[41] = ((u32[50]|0) ? fround(f32[48]) : fround(f32[41]));
      f32[43] = ((u32[50]|0) ? fround(f32[47]) : fround(f32[43]));
      f32[44] = ((u32[50]|0) ? fround(f32[45]) : fround(f32[44]));
      f32[41] = ((u32[49]|0) ? fround(f32[47]) : fround(f32[41]));
      f32[43] = ((u32[49]|0) ? fround(f32[46]) : fround(f32[43]));
      f32[44] = ((u32[49]|0) ? fround(f32[45]) : fround(f32[44]));
      f32[41] = ((u32[42]|0) ? fround(f32[41]) : fround(f32[47]));
      f32[42] = ((u32[42]|0) ? fround(f32[43]) : fround(f32[47]));
      f32[43] = ((u32[42]|0) ? fround(f32[44]) : fround(f32[47]));
      u32[45] = (fround(f32[41]) < fround(f32[13]) ? -1 : 0);
      u32[46] = (fround(f32[42]) < fround(f32[13]) ? -1 : 0);
      u32[47] = (fround(f32[43]) < fround(f32[13]) ? -1 : 0);
      f32[49] = f32[41] * f32[14];
      f32[50] = f32[42] * f32[14];
      f32[51] = f32[43] * f32[14];
      f32[41] = f32[41] + f32[15];
      f32[42] = f32[42] + f32[15];
      f32[43] = f32[43] + f32[15];
      f32[41] = fround(abs(+f32[41])) * f32[16];
      f32[42] = fround(abs(+f32[42])) * f32[16];
      f32[43] = fround(abs(+f32[43])) * f32[16];
      f32[41] = log(+f32[41]);
      f32[42] = log(+f32[42]);
      f32[43] = log(+f32[43]);
      f32[41] = f32[41] * f32[2];
      f32[42] = f32[42] * f32[2];
      f32[43] = f32[43] * f32[2];
      f32[41] = exp(+f32[41]);
      f32[42] = exp(+f32[42]);
      f32[43] = exp(+f32[43]);
      f32[41] = ((u32[45]|0) ? fround(f32[49]) : fround(f32[41]));
      f32[42] = ((u32[46]|0) ? fround(f32[50]) : fround(f32[42]));
      f32[43] = ((u32[47]|0) ? fround(f32[51]) : fround(f32[43]));
      u32[45] = (fround(f32[26]) < fround(f32[13]) ? -1 : 0);
      u32[46] = (fround(f32[27]) < fround(f32[13]) ? -1 : 0);
      u32[47] = (fround(f32[28]) < fround(f32[13]) ? -1 : 0);
      f32[49] = f32[26] * f32[14];
      f32[50] = f32[27] * f32[14];
      f32[51] = f32[28] * f32[14];
      f32[53] = f32[26] + f32[15];
      f32[54] = f32[27] + f32[15];
      f32[55] = f32[28] + f32[15];
      f32[53] = fround(abs(+f32[53])) * f32[16];
      f32[54] = fround(abs(+f32[54])) * f32[16];
      f32[55] = fround(abs(+f32[55])) * f32[16];
      f32[53] = log(+f32[53]);
      f32[54] = log(+f32[54]);
      f32[55] = log(+f32[55]);
      f32[53] = f32[53] * f32[2];
      f32[54] = f32[54] * f32[2];
      f32[55] = f32[55] * f32[2];
      f32[53] = exp(+f32[53]);
      f32[54] = exp(+f32[54]);
      f32[55] = exp(+f32[55]);
      f32[45] = ((u32[45]|0) ? fround(f32[49]) : fround(f32[53]));
      f32[46] = ((u32[46]|0) ? fround(f32[50]) : fround(f32[54]));
      f32[47] = ((u32[47]|0) ? fround(f32[51]) : fround(f32[55]));
      f32[45] = fround(f32[41] * f32[45]) + fround(-f32[41]);
      f32[46] = fround(f32[42] * f32[46]) + fround(-f32[42]);
      f32[47] = fround(f32[43] * f32[47]) + fround(-f32[43]);
      f32[41] = fround(f32[29] * f32[45]) + f32[41];
      f32[42] = fround(f32[29] * f32[46]) + f32[42];
      f32[43] = fround(f32[29] * f32[47]) + f32[43];
    } else {
      u32[45] = (fround(f32[37]) < fround(f32[13]) ? -1 : 0);
      u32[46] = (fround(f32[38]) < fround(f32[13]) ? -1 : 0);
      u32[47] = (fround(f32[39]) < fround(f32[13]) ? -1 : 0);
      f32[49] = f32[37] * f32[14];
      f32[50] = f32[38] * f32[14];
      f32[51] = f32[39] * f32[14];
      f32[37] = f32[37] + f32[15];
      f32[38] = f32[38] + f32[15];
      f32[39] = f32[39] + f32[15];
      f32[37] = fround(abs(+f32[37])) * f32[16];
      f32[38] = fround(abs(+f32[38])) * f32[16];
      f32[39] = fround(abs(+f32[39])) * f32[16];
      f32[37] = log(+f32[37]);
      f32[38] = log(+f32[38]);
      f32[39] = log(+f32[39]);
      f32[37] = f32[37] * f32[2];
      f32[38] = f32[38] * f32[2];
      f32[39] = f32[39] * f32[2];
      f32[37] = exp(+f32[37]);
      f32[38] = exp(+f32[38]);
      f32[39] = exp(+f32[39]);
      f32[41] = ((u32[45]|0) ? fround(f32[49]) : fround(f32[37]));
      f32[42] = ((u32[46]|0) ? fround(f32[50]) : fround(f32[38]));
      f32[43] = ((u32[47]|0) ? fround(f32[51]) : fround(f32[39]));
    }
    f32[36] = f32[40] * f32[0];
    u32[37] = (fround(f32[41]) < fround(f32[17]) ? -1 : 0);
    u32[38] = (fround(f32[42]) < fround(f32[17]) ? -1 : 0);
    u32[39] = (fround(f32[43]) < fround(f32[17]) ? -1 : 0);
    f32[45] = f32[41] * f32[1];
    f32[46] = f32[42] * f32[1];
    f32[47] = f32[43] * f32[1];
    f32[40] = f32[0] / f32[2];
    f32[41] = log(+fround(abs(+f32[41])));
    f32[42] = log(+fround(abs(+f32[42])));
    f32[43] = log(+fround(abs(+f32[43])));
    f32[41] = f32[40] * f32[41];
    f32[42] = f32[40] * f32[42];
    f32[43] = f32[40] * f32[43];
    f32[41] = exp(+f32[41]);
    f32[42] = exp(+f32[42]);
    f32[43] = exp(+f32[43]);
    f32[41] = fround(f32[41] * f32[18]) + f32[19];
    f32[42] = fround(f32[42] * f32[18]) + f32[19];
    f32[43] = fround(f32[43] * f32[18]) + f32[19];
    f32[33] = ((u32[37]|0) ? fround(f32[45]) : fround(f32[41]));
    f32[34] = ((u32[38]|0) ? fround(f32[46]) : fround(f32[42]));
    f32[35] = ((u32[39]|0) ? fround(f32[47]) : fround(f32[43]));
  }

  function tint(size) {
    size = size|0;
    var posi = 256, poso = 0;
    poso = (256 + (size << 2))|0;
    while ((size|0) > 0) {
      f32[37] = +(u8[posi|0]>>>0) / 255.0;
      f32[38] = +(u8[(posi+1)|0]>>>0) / 255.0;
      f32[39] = +(u8[(posi+2)|0]>>>0) / 255.0;
      f32[40] = +(u8[(posi+3)|0]>>>0) / 255.0;
      pixelTint();
      u8[poso|0] = min(max(~~(+f32[33] * 255.0 + 0.5), 0), 255);
      u8[(poso+1)|0] = min(max(~~(+f32[34] * 255.0 + 0.5), 0), 255);
      u8[(poso+2)|0] = min(max(~~(+f32[35] * 255.0 + 0.5), 0), 255);
      u8[(poso+3)|0] = min(max(~~(+f32[36] * 255.0 + 0.5), 0), 255);
      posi = (posi + 4)|0;
      poso = (poso + 4)|0;
      size = (size - 1)|0;
    }
    return posi|0;
  }

  function palette(size) {
    size = size|0;
    var posi = 256, poso = 0;
    poso = (256 + (size << 2))|0;
    while ((size|0) > 0) {
      f32[37] = +(u8[posi|0]>>>0) / 255.0;
      f32[38] = +(u8[(posi+1)|0]>>>0) / 255.0;
      f32[39] = +(u8[(posi+2)|0]>>>0) / 255.0;
      f32[40] = +(u8[(posi+3)|0]>>>0) / 255.0;
      pixelPalette();
      u8[poso|0] = min(max(~~(+f32[33] * 255.0 + 0.5), 0), 255);
      u8[(poso+1)|0] = min(max(~~(+f32[34] * 255.0 + 0.5), 0), 255);
      u8[(poso+2)|0] = min(max(~~(+f32[35] * 255.0 + 0.5), 0), 255);
      u8[(poso+3)|0] = min(max(~~(+f32[36] * 255.0 + 0.5), 0), 255);
      posi = (posi + 4)|0;
      poso = (poso + 4)|0;
      size = (size - 1)|0;
    }
    return posi|0;
  }

  return { tint: tint, palette: palette };
}

const heap = new ArrayBuffer(65536);
const HEAPF32 = new Float32Array(heap);
HEAPF32.set([1, 12.919993, 2.4, 0, 0.5, 0.16666667, 0.33333334, 0.66666669, -1, 6, 2, 3, 4, 0.04045, 0.07739938, 0.055, 0.94786733, 0.0031308, 1.055, -0.055], 0);
const HEAPU8 = new Uint8Array(heap);
const calculator = ColorCalculator(window, null, heap);

const tintTable = [
  [0, 0, 0, 0, 0, 0], // NONE
  [0, 0, 0, 0, 0, 0], // GREY
  [0, 0.501, 0.14, 0.14, 0.425, 0.54], // GREY2
  [0, 0, 0, 0, 0, 0], // GOLD
  [0, 0, 0, 0, 0, 0], // BROWN
  [0, 0.501, 0.175, 0.175, 0.4, 0.4], // GREYBROWN
  [0, 0, 0, 0, 0, 0], // INV_GREY
  [0, 0, 0, 0, 0, 0], // INV_GREY2
  [0.05, 0.06, 0.5, 0.501, 0.585, 0.415], // INV_GREYBROWN
];
const tintColor = [
  /* whit */ [0, 0, 0, 0, 0, -0.5, 0.5],
  /* lgry */ [0, 0, 0, 0, 0, -0.55, -0.35],
  /* dgry */ [0, 0, 0, 0, 0, -0.6, -0.5],
  /* blac */ [0, 0, 0, 0, 0, -0.65, -0.65],
  /* lblu */ [0.595, 0.96, 0.98, 0.4, -0.47, 0.2, 0.6],
  /* dblu */ [0.473, 0.77, 0.788, 0.6, -0.46, 0.25, 0.2],
  /* cblu */ [0.427, 0.698, 0.728, 0.5, 0.58, 0.2, 0.5],
  /* lred */ [1, 0, 0, 0.5, 0, 0.25, 0.55],
  /* dred */ [1, 0, 0, 0.5, 0, 0.75, -0.35],
  /* cred */ [0.9, 0.1, 0, 0.7, 0, 1, 0.5],
  /* lgrn */ [0, 1, 0, 0.4, 0.25, 0.25, 0.3],
  /* dgrn */ [0, 1, 0, 0.3, 0.25, 0, -0.3],
  /* cgrn */ [0, 1, 0, 0.3, 0.25, 1, 0.4],
  /* lyel */ [0.8, 0.68, 0.25, 0.8, 0.065, 0.4, 0.4],
  /* dyel */ [0.57, 0.49, 0.28, 0.7, 0.05, 0.4, -0.2],
  /* lgld */ [0.882, 0.813, 0.71, 0.6, 0.04, 0, 0.5],
  /* dgld */ [0.686275, 0.403922, 0.011765, 0.6, 0, 0, 0.5],
  /* lpur */ [0.553, 0.137, 0.51, 0.3, -0.33, 0.8, 0.4],
  /* dpur */ [0.553, 0.137, 0.51, 0.75, -0.16, 0.35, -0.25],
  /* oran */ [1, 0.25, 0, 0.42, 0.04, 0.3, 0],
  /* bwht */ [0, 0, 0, 0, 0, -0.5, 1.05],
];

const tintName = [
  'whit', 'lgry', 'dgry', 'blac', 'lblu', 'dblu', 'cblu', 'lred', 'dred', 'cred',
  'lgrn', 'dgrn', 'cgrn', 'lyel', 'dyel', 'lgld', 'dgld', 'lpur', 'dpur', 'oran', 'bwht'
];

const tintExtra = ['ffffff', 'ff4d4d', '00ff00', '6969ff', 'c7b377', '797979', '000000', 'd0c27d', 'ffa800', 'ffff64', '008000', 'ae00ff', '00c800'].map(color => {
  const r = parseInt(color.substring(0, 2), 16) / 255;
  const g = parseInt(color.substring(2, 4), 16) / 255;
  const b = parseInt(color.substring(4, 6), 16) / 255;
  return [r, g, b, 1.0];
});
tintExtra[1] = [1.0, 0.3, 0.3, 1.0];
tintExtra[5] = [0.5, 0.5, 0.5, 1.0];
tintExtra[6] = [1.5, 1.5, 1.5, 1.0];

export function hd_applyTint(bits, size, tint, name) {
  const tablei = Math.floor(tint / 21), colori = tint % 21;
  if (tablei < 9) HEAPF32.set(Data.colorRangeOverride[name] || tintTable[Math.floor(tint / 21)], 20);
  HEAPF32.set(tablei < 9 ? (Data.colorTransformOverride[`${name}:${tintName[tint % 21]}`] || tintColor[tint % 21]) : tintExtra[colori], 26);
  HEAPU8.set(bits, 256);

  const offset = (tablei < 9 ? calculator.palette(size) : calculator.tint(size));

  return HEAPU8.subarray(offset, offset + size * 4);
}
